import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

const SpecialRequestsReadOnlyModal = ({
  isOpen,
  onClose,
  note = '',
  title,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const modal = (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.55)',
        backdropFilter: 'blur(6px)',
        zIndex: 10050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 720,
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
          overflow: 'hidden',
          border: '1px solid #e2e8f0',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
          }}
        >
          <div style={{ fontWeight: 800, color: '#0f172a' }}>
            {title || t('receptionInpatients.specialRequests.title', { defaultValue: 'Special Requests' })}
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              border: 'none',
              background: 'transparent',
              color: '#94a3b8',
              cursor: 'pointer',
            }}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        <div style={{ padding: 20 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 700, color: '#475569', marginBottom: 8 }}>
            {t('receptionInpatients.specialRequests.noteLabel', { defaultValue: 'Notes' })}
          </label>
          <textarea
            readOnly
            value={note || ''}
            placeholder={t('receptionInpatients.specialRequests.empty', { defaultValue: 'No special requests were added.' })}
            style={{
              width: '100%',
              minHeight: 180,
              resize: 'vertical',
              padding: 14,
              borderRadius: 12,
              border: '1px solid #e2e8f0',
              background: '#f8fafc',
              color: '#0f172a',
              outline: 'none',
              fontSize: 14,
              lineHeight: 1.5,
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '14px 20px',
            borderTop: '1px solid #e2e8f0',
            background: '#fff',
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '10px 16px',
              borderRadius: 12,
              border: '1px solid #e2e8f0',
              background: '#f8fafc',
              color: '#334155',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            {t('common.close', { defaultValue: 'Close' })}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default SpecialRequestsReadOnlyModal;

